import Axios from 'axios'
import { Dispatch } from 'redux'

import { ActionResponse } from 'util/types/index'
import { PartnerProduct } from 'panel/partner/product-config/redux/types'
import { Product, ProductTypes } from './types'
import { clearAlert, createAlert, handleError } from 'util/modules/Alert/redux/actions'

export function createProduct (partnerId: string|number, data: FormData) {
  return async (dispatch: Dispatch): Promise<ActionResponse<Product & { pProduct: PartnerProduct }>> => {
    createAlert({ code: 100, title: 'Cadastrando Produto', message: 'Aguarde...' })(dispatch)

    return Axios
      .post(`/partner/${partnerId}/product`, data)
      .then(res => res.data)
      .then(res => {
        if (res?.status === 'success' && res?.data) {
          dispatch({ type: ProductTypes.PRODUCT_CREATE, payload: res.data })
        }
        return res
      })
      .catch((error) => {
        return handleError(error, 'Ocorreu um erro ao cadastrar o produto')
      })
      .then(async res => {
        createAlert(res)(dispatch)
        await clearAlert(1500)(dispatch)

        return res
      })
  }
}

export function updateProduct (partnerId: string|number, id: number|string, data: FormData) {
  return async (dispatch: Dispatch): Promise<ActionResponse<Product>> => {
    createAlert({ code: 100, title: 'Atualizando Produto', message: 'Aguarde...' })(dispatch)
    return Axios
      .put(`/partner/${partnerId}/product/${id}`, data)
      .then(res => res.data)
      .then(res => {
        if (res?.status === 'success' && res?.data) {
          dispatch({ type: ProductTypes.PRODUCT_UPDATE, payload: res.data })
        }
        return res
      })
      .catch((error) => {
        return handleError(error, 'Ocorreu um erro ao atualizar o produto')
      })
      .then(async res => {
        createAlert(res)(dispatch)
        await clearAlert(1500)(dispatch)

        return res
      })
  }
}

export function deleteProduct (partnerId: number|string, id: number|string) {
  return async (dispatch: Dispatch): Promise<ActionResponse<Product>> => {
    createAlert({ code: 100, title: 'Removendo Produto', message: 'Aguarde...' })(dispatch)
    return Axios
      .delete(`/partner/${partnerId}/product/${id}`)
      .then(res => res.data)
      .then(res => {
        if (res?.status === 'success' && res?.data) {
          dispatch({ type: ProductTypes.PRODUCT_DELETE, payload: res.data })
        }
        return res
      })
      .catch((error) => {
        return handleError(error, 'Ocorreu um erro ao remover o produto')
      })
      .then(async res => {
        createAlert(res)(dispatch)
        await clearAlert(1500)(dispatch)

        return res
      })
  }
}

export function getProduct (partnerId: number|string, id: number|string) {
  return async (dispatch: Dispatch): Promise<ActionResponse<Product>> => {
    return Axios
      .get(`/partner/${partnerId}/product/${id}`)
      .then(res => res.data)
      .then(res => {
        if (res?.status === 'success' && res.data) {
          dispatch({ type: ProductTypes.PRODUCT_GET, payload: res.data })
        }
        return res
      })
  }
}

export function getProductList (partnerId: number|string, params?: Record<string, string|number>) {
  return async (dispatch: Dispatch): Promise<ActionResponse<Product[]>> => {
    return Axios
      .get(`/partner/${partnerId}/product`, { params })
      .then(res => res.data)
      .then(res => {
        if (res?.status === 'success' && res.data) {
          dispatch({ type: ProductTypes.PRODUCT_LIST, payload: res.data, pagination: res.pagination })
        }
        return res
      })
  }
}
